module.exports = __webpack_public_path__ + "img/ring.f98a2c1d.svg";